import React, { useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import MindmatchGame from '../components/minigames/MindmatchGame';
import ExternalGamesLibrary from '../components/minigames/ExternalGamesLibrary';

export const Minigames = () => {
    const [activeView, setActiveView] = useState(0);

    return (
        <div className="minigames-container">
            <h1 className="titleMiniGames">Frazzaplay</h1>

            <TabView activeIndex={activeView} onTabChange={(e) => setActiveView(e.index)} className="minigames-tab">
                <TabPanel header="Mindmatch 4D">
                    <MindmatchGame />
                </TabPanel>

                <TabPanel header="Game Library">
                    <ExternalGamesLibrary />
                </TabPanel>

                <TabPanel header="More games soon">
                    <div className="construction-container">
                        <div className="construction-content">
                            <div className="construction-icon">
                                🚧
                            </div>
                            <h2 className="construction-title">Under Construction</h2>
                            <p className="construction-message">More exciting games coming soon!</p>

                            <div className="construction-progress">
                                <div className="progress-bar">
                                    <div className="progress-fill"></div>
                                </div>
                                <p className="progress-text">Development in progress...</p>
                            </div>
                        </div>
                    </div>
                </TabPanel>
            </TabView>
        </div>
    );
};

export default Minigames;
